// extracted by mini-css-extract-plugin
export default {"overview":"dashboard_overview__Gur7Q","background":"dashboard_background__7Tk+v"};